import { PaywallCustomization } from "../../PaywallCustomization";
import { CouponTag } from "./CouponTag";
import { PriceDisplay } from "./PriceDisplay";
import { PriceSubtitle } from "./PriceSubtitle";
import type { PriceScenariosProps } from "./types";

export const PriceDescription = (props: PriceScenariosProps) => {
  const { price } = props;

  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-col gap-y-1">
        <PaywallCustomization.ReducedPrice price={price}>
          <PriceDisplay {...props} />
        </PaywallCustomization.ReducedPrice>
        <PaywallCustomization.PriceCallout price={price}>
          <PaywallCustomization.ReducedPrice price={price}>
            <PriceSubtitle {...props} />
          </PaywallCustomization.ReducedPrice>
        </PaywallCustomization.PriceCallout>
      </div>
      <CouponTag paywallPriceId={price.id} />
    </div>
  );
};
